import GiftCardsList from './GiftCardsList';

export default GiftCardsList;
